/*
 * Wishlist page (sections/main-wishlist.liquid).
 * Own list: from window.BABWishlist (localStorage). Shared list: ?items=handle1,handle2.
 */
(function () {
  const page = document.querySelector('[data-wishlist-page]');
  if (!page || !window.BABWishlist) return;

  const WL = window.BABWishlist;
  const $ = (sel, root) => (root || page).querySelector(sel);
  const $$ = (sel, root) => [...(root || page).querySelectorAll(sel)];
  let texts = {};
  try {
    texts = JSON.parse($('[data-wl-texts]').textContent);
  } catch (e) {}

  const root = (page.dataset.root || '/').replace(/\/?$/, '/');
  const freeShipping = Number(page.dataset.freeShipping || 0);
  const lowStock = Number(page.dataset.lowStock || 5);
  const HANDLE_RE = /^[a-z0-9][a-z0-9\-]*$/i;

  const params = new URLSearchParams(window.location.search);
  const sharedHandles = (params.get('items') || '')
    .split(',')
    .map((h) => h.trim())
    .filter((h) => HANDLE_RE.test(h))
    .slice(0, 50);
  const shared = sharedHandles.length > 0;

  const grid = $('[data-wl-grid]');
  let shownHandles = [];

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    const format = WL.moneyFormat || '{{amount_with_comma_separator}} kr';
    const value = (Number(cents) || 0) / 100;
    const fmt = (decimals, thousands, dec) => {
      const fixed = value.toFixed(decimals).split('.');
      const int = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fixed[1] ? int + dec + fixed[1] : int;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return fmt(0, ',', '.');
        case 'amount_with_comma_separator':
          return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return fmt(2, "'", '.');
        default:
          return fmt(2, ',', '.');
      }
    });
  }

  const t = (key, vars) => {
    let str = texts[key] || '';
    Object.entries(vars || {}).forEach(([k, v]) => (str = str.split(`[${k}]`).join(v)));
    return str;
  };

  const push = (event, data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event, wishlist_source: 'theme' }, data || {}));
  };

  function fillTexts(scope) {
    $$('[data-wl-text]', scope).forEach((el) => (el.textContent = texts[el.dataset.wlText] || ''));
    $$('[data-wl-text-aria]', scope).forEach((el) => el.setAttribute('aria-label', texts[el.dataset.wlTextAria] || ''));
  }

  /* ---------- rendering ---------- */
  async function fetchItem(handle) {
    try {
      const res = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=wishlist-item`);
      if (!res.ok) return { handle, missing: res.status === 404 };
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const item = doc.querySelector('[data-wl-item]');
      return item ? { handle, node: item } : { handle, missing: true };
    } catch (e) {
      return { handle };
    }
  }

  async function render() {
    const handles = shared ? sharedHandles : WL.get().map((i) => i.h);
    shownHandles = handles.slice();

    $('[data-wl-shared]').hidden = !shared;
    $('[data-wl-heading-own]').hidden = shared;
    $('[data-wl-heading-shared]').hidden = !shared;

    if (handles.length === 0) {
      grid.innerHTML = '';
      showEmpty(true);
      return;
    }
    showEmpty(false);

    const results = await Promise.all(handles.map(fetchItem));
    // Products that no longer exist are dropped from the visitor's own list.
    if (!shared) results.filter((r) => r.missing).forEach((r) => WL.remove(r.handle));

    const stored = new Map(WL.get().map((i) => [i.h, i]));
    grid.innerHTML = '';
    results.forEach((r) => {
      if (!r.node) return;
      const node = document.importNode(r.node, true);
      fillTexts(node);
      if (shared) node.querySelector('[data-wl-remove]')?.remove();
      grid.appendChild(node);
      setupItem(node, stored.get(r.handle));
    });

    if (!grid.children.length) {
      showEmpty(true);
      return;
    }
    updateSummary();
    loadRecommendations();
  }

  function showEmpty(isEmpty) {
    $('[data-wl-empty]').hidden = !isEmpty;
    $('[data-wl-actions]').hidden = isEmpty;
    $('[data-wl-meta]').hidden = isEmpty;
    $('[data-wl-sticky]').hidden = isEmpty;
    const fs = $('[data-wl-fs]');
    if (fs) fs.hidden = isEmpty;
    const recs = $('[data-wl-recs]');
    if (recs && isEmpty) recs.hidden = true;
    if (isEmpty) grid.innerHTML = '';
  }

  function selectedOption(item) {
    const input = item.querySelector('[data-wl-variant]');
    return input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
  }

  function refreshItem(item, storedEntry) {
    const opt = selectedOption(item);
    const price = Number(opt.dataset.price);
    const compare = Number(opt.dataset.compare);
    const available = opt.dataset.available === 'true';
    const qty = opt.dataset.qty === '' ? null : Number(opt.dataset.qty);

    const priceEl = item.querySelector('[data-wl-price]');
    const compareEl = item.querySelector('[data-wl-compare]');
    priceEl.textContent = formatMoney(price);
    priceEl.classList.toggle('is-sale', compare > price);
    compareEl.hidden = !(compare > price);
    if (compare > price) compareEl.textContent = formatMoney(compare);

    const note = item.querySelector('[data-wl-note]');
    if (available && qty !== null && qty > 0 && qty <= lowStock) {
      note.textContent = t('low_stock', { antal: qty });
      note.hidden = false;
    } else {
      note.hidden = true;
    }

    const atc = item.querySelector('[data-wl-atc]');
    atc.disabled = !available;
    atc.classList.remove('is-added');
    atc.querySelector('[data-wl-text]').textContent = available ? texts.add_to_cart : texts.sold_out;

    // Price-drop badge: current price is lower than when it was saved.
    const badges = item.querySelector('[data-wl-badges]');
    badges.querySelector('.wl-badge--drop')?.remove();
    if (storedEntry && storedEntry.p && price < storedEntry.p && available) {
      const b = document.createElement('span');
      b.className = 'wl-badge wl-badge--drop';
      b.textContent = texts.price_drop || '';
      badges.appendChild(b);
    }
  }

  function setupItem(item, storedEntry) {
    refreshItem(item, storedEntry);
    const select = item.querySelector('select[data-wl-variant]');
    if (select) {
      select.addEventListener('change', () => {
        refreshItem(item, storedEntry);
        updateSummary();
      });
    }
    item.querySelector('[data-wl-remove]')?.addEventListener('click', () => {
      item.classList.add('is-removing');
      setTimeout(() => {
        item.remove();
        shownHandles = shownHandles.filter((h) => h !== item.dataset.handle);
        WL.remove(item.dataset.handle);
        if (!grid.children.length) showEmpty(true);
        else updateSummary();
      }, 220);
    });
    item.querySelector('[data-wl-atc]').addEventListener('click', (e) => addToCart([item], e.currentTarget));
  }

  /* ---------- summary / free shipping ---------- */
  let cartTotal = 0;

  function availableItems() {
    return $$('[data-wl-item]', grid).filter((item) => selectedOption(item).dataset.available === 'true');
  }

  function listTotal() {
    return availableItems().reduce((sum, item) => sum + Number(selectedOption(item).dataset.price || 0), 0);
  }

  function updateSummary() {
    const count = $$('[data-wl-item]', grid).length;
    const countText = count === 1 ? texts.count_one : t('count_other', { antal: count });
    $$('[data-wl-count]').forEach((el) => (el.textContent = countText));
    $$('[data-wl-total]').forEach((el) => (el.textContent = formatMoney(listTotal())));
    $$('[data-wl-add-all]').forEach((btn) => (btn.disabled = availableItems().length === 0));
    updateFreeShipping();
  }

  async function loadCart() {
    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      cartTotal = cart.total_price || 0;
    } catch (e) {}
    updateFreeShipping();
  }

  function updateFreeShipping() {
    const fs = $('[data-wl-fs]');
    if (!fs || !freeShipping || !grid.children.length) return;
    const text = $('[data-wl-fs-text]');
    const bar = $('[data-wl-fs-bar]');
    const withList = cartTotal + listTotal();
    if (cartTotal >= freeShipping) text.textContent = texts.fs_reached;
    else if (withList >= freeShipping) text.textContent = texts.fs_with_list;
    else text.textContent = t('fs_missing', { 'beløb': formatMoney(freeShipping - withList) });
    bar.style.width = Math.min(100, (withList / freeShipping) * 100) + '%';
    fs.hidden = false;
  }

  /* ---------- cart ---------- */
  async function postCart(items) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || 'error');
    return data.items || [data];
  }

  async function addToCart(itemEls, button) {
    const lines = itemEls.map((el) => ({ id: Number(selectedOption(el).value), quantity: 1 }));
    if (!lines.length) return;
    const label = button.querySelector('[data-wl-text], [data-wl-add-all-label]') || button;
    const original = label.textContent;
    button.disabled = true;
    let added = [];
    try {
      added = await postCart(lines);
    } catch (e) {
      // One unavailable line fails the whole request — retry line by line.
      for (const line of lines) {
        try {
          added = added.concat(await postCart([line]));
        } catch (err) {}
      }
    }

    if (added.length) {
      added.forEach((p) => document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: p } })));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      if (itemEls.length > 1) push('wishlist_add_all_to_cart', { items_added: added.length });
      label.textContent = itemEls.length > 1 ? texts.add_all_done : texts.added;
      button.classList.add('is-added');
      loadCart();
      setTimeout(() => {
        label.textContent = original;
        button.classList.remove('is-added');
        button.disabled = false;
      }, 2500);
    } else {
      label.textContent = texts.error;
      setTimeout(() => {
        label.textContent = original;
        button.disabled = false;
      }, 2500);
    }
  }

  $$('[data-wl-add-all]').forEach((btn) => btn.addEventListener('click', () => addToCart(availableItems(), btn)));

  /* ---------- shared list ---------- */
  $('[data-wl-save-shared]').addEventListener('click', (e) => {
    const stored = new Set(WL.get().map((i) => i.h));
    const list = WL.get();
    $$('[data-wl-item]', grid).forEach((item) => {
      if (!stored.has(item.dataset.handle)) {
        list.unshift({ h: item.dataset.handle, p: Number(selectedOption(item).dataset.price) || null, t: Date.now() });
      }
    });
    WL.replace(list);
    push('wishlist_save_shared', { items: list.length });
    e.currentTarget.textContent = texts.shared_saved;
    e.currentTarget.disabled = true;
  });

  /* ---------- share ---------- */
  const dialog = $('[data-wl-share]');
  function shareUrl() {
    const handles = $$('[data-wl-item]', grid).map((el) => el.dataset.handle);
    const url = new URL(WL.pageUrl, window.location.origin);
    url.search = '';
    url.searchParams.set('items', handles.join(','));
    return url.toString().replace(/%2C/g, ',');
  }
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  $('[data-wl-share-open]').addEventListener('click', () => {
    const url = shareUrl();
    const msg = texts.share_title || '';
    $('[data-wl-share-url]').value = url;
    $('[data-wl-channel="sms"]').href = `sms:?&body=${encodeURIComponent(msg + ' ' + url)}`;
    $('[data-wl-channel="whatsapp"]').href = `https://wa.me/?text=${encodeURIComponent(msg + ' ' + url)}`;
    $('[data-wl-channel="email"]').href = `mailto:?subject=${encodeURIComponent(msg)}&body=${encodeURIComponent(msg + '\n\n' + url)}`;
    const messenger = $('[data-wl-channel="messenger"]');
    messenger.hidden = !isMobile;
    messenger.href = `fb-messenger://share/?link=${encodeURIComponent(url)}`;
    $('[data-wl-native]').hidden = !navigator.share;
    if (dialog.showModal) dialog.showModal();
    else dialog.setAttribute('open', '');
    push('wishlist_share_open');
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close();
    const channel = e.target.closest('[data-wl-channel]');
    if (channel) push('wishlist_share', { method: channel.dataset.wlChannel });
  });

  $('[data-wl-copy]').addEventListener('click', async (e) => {
    const btn = e.currentTarget;
    const input = $('[data-wl-share-url]');
    try {
      await navigator.clipboard.writeText(input.value);
    } catch (err) {
      input.select();
      document.execCommand && document.execCommand('copy');
    }
    const original = btn.textContent;
    btn.textContent = texts.copied;
    push('wishlist_share', { method: 'copy' });
    setTimeout(() => (btn.textContent = original), 2000);
  });

  $('[data-wl-native]').addEventListener('click', async () => {
    try {
      await navigator.share({ title: texts.share_title, text: texts.share_title, url: $('[data-wl-share-url]').value });
      push('wishlist_share', { method: 'native' });
    } catch (e) {}
  });

  /* ---------- recommendations ---------- */
  let recsLoaded = false;
  async function loadRecommendations() {
    const wrap = $('[data-wl-recs]');
    if (!wrap || recsLoaded) return;
    const first = $('[data-wl-item]', grid);
    if (!first) return;
    recsLoaded = true;
    try {
      const url = `${page.dataset.recsUrl}?product_id=${first.dataset.productId}&limit=10&section_id=wishlist-recommendations`;
      const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
      const inList = new Set($$('[data-wl-item]', grid).map((el) => el.dataset.handle));
      const cards = [...doc.querySelectorAll('.wl-recs__item')].filter((c) => !inList.has(c.dataset.handle)).slice(0, 4);
      if (!cards.length) return;
      const target = $('[data-wl-recs-target]');
      target.innerHTML = '';
      cards.forEach((c) => target.appendChild(document.importNode(c, true)));
      wrap.hidden = false;
    } catch (e) {}
  }

  /* ---------- keep in sync with hearts elsewhere / other tabs ---------- */
  if (!shared) {
    WL.subscribe((list) => {
      const handles = list.map((i) => i.h);
      const same = handles.length === shownHandles.length && handles.every((h) => shownHandles.includes(h));
      if (!same) {
        recsLoaded = false;
        render();
      }
    });
  }

  render();
  loadCart();
})();
